var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33342 11.0332L5.33342 2.91654L1.60008 6.64987L0.666748 5.69987L6.00008 0.366536L11.3334 5.69987L10.4001 6.64987L6.66675 2.91654L6.66675 11.0332H5.33342Z",
    fill: "#EA7D16"
  })));
}

export default __webpack_public_path__ + "media/a313375d.svg";
export { SvgArrowUp as ReactComponent };